import ChipSelect from "@/components/ChipSelect";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetFooter, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import type { PitchStatus } from "@/shared/types";
import { emptyPitchStatusFilter, type PitchStatusFilter } from "@/utils/pitching/filter";

const PITCH_STATUS_OPTIONS: { status: PitchStatus; label: string }[] = [
    { status: "pitched", label: "Pitched" },
    { status: "needs-info", label: "Needs info" },
    { status: "approved", label: "Accepted" },
    { status: "rejected", label: "Rejected" },
    { status: "withdrawn", label: "Withdrawn" },
];
const PITCH_STATUSES = PITCH_STATUS_OPTIONS.map((option) => option.status);
const PITCH_STATUS_NAMES = PITCH_STATUS_OPTIONS.map((option) => option.label);

type PitchFilterSheetProps = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    value: PitchStatusFilter;
    onChange: (value: PitchStatusFilter) => void;
};

/** Pitch table filters: ChipSelect for pitch status. Shared by Campaign pitches and My Pitches. */
export function PitchFilterSheet({ open, onOpenChange, value, onChange }: PitchFilterSheetProps) {
    return (
        <Sheet open={open} onOpenChange={onOpenChange}>
            <SheetContent side="right" className="sm:max-w-xl">
                <SheetHeader>
                    <SheetTitle>Filters</SheetTitle>
                </SheetHeader>
                <div className="min-h-0 flex-1 overflow-y-auto px-4">
                    <ChipSelect
                        label={value.length ? `Status: ${value.length}` : "Status"}
                        active={value.length > 0}
                        options={PITCH_STATUSES}
                        names={PITCH_STATUS_NAMES}
                        value={[...value]}
                        onChange={(next) => onChange([...(next as PitchStatus[])])}
                    />
                </div>
                <SheetFooter className="flex-row justify-end">
                    <Button type="button" variant="outline" onClick={() => onChange(emptyPitchStatusFilter)}>
                        Clear all
                    </Button>
                    <Button type="button" onClick={() => onOpenChange(false)}>
                        Done
                    </Button>
                </SheetFooter>
            </SheetContent>
        </Sheet>
    );
}
